import React from 'react'
import { Bell, MessageSquare } from 'lucide-react'
import styles from './filter-tabs.module.scss'
import PurpleBoostIcon from 'components/votes/PurpleBoostIcon'
import Tabs from './Tabs'

export default function NotificationTabs({ activeTab, onTabChange }) {
    const tabs = [
        { key: 'all', label: 'All', icon: Bell },
        { key: 'messages', label: 'Messages', icon: MessageSquare },
        // Upvals tab intentionally hidden.
        {
            key: 'system',
            label: 'Treechat',
            renderIcon: active => (
                <PurpleBoostIcon
                    contextStyles={active ? styles.purpleBoostIcon : styles.boostIcon}
                />
            ),
        },
    ]

    return (
        <Tabs
            ariaLabel="Notification tabs"
            activeTab={activeTab}
            onTabChange={onTabChange}
            tabs={tabs}
        />
    )
}
